import clsx from 'clsx'
import { FC, ReactNode } from 'react'
import { ClassName } from 'types/props'

import classes from './index.module.scss'

interface WrapperProps extends ClassName {
  children?: ReactNode
  spacing?: 'xs' | 'sm' | 'md'
}
const Wrapper: FC<WrapperProps> = ({ children, className, spacing = 'md' }: WrapperProps) => (
  <div className={clsx(classes.root, className, classes[spacing])}>{children}</div>
)

interface HeaderProps {
  alignChildrenRight?: boolean
  title?: string
}
const Header: FC<HeaderProps> = ({ alignChildrenRight = false, children, title }) => (
  <header className={clsx(classes.header, { 'flex-space-between': alignChildrenRight })}>
    {title && <h5>{title}</h5>}
    {children}
  </header>
)

export const Card = {
  Wrapper,
  Header
}
